let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lVWr4")).then(() => parcelRequire('giSOD'));